'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _airbrakeJs = require('airbrake-js');

var _airbrakeJs2 = _interopRequireDefault(_airbrakeJs);

var _detectBrowser = require('detect-browser');

var _detectBrowser2 = _interopRequireDefault(_detectBrowser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AirbrakeErrorService = function () {
  function AirbrakeErrorService() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, AirbrakeErrorService);

    var projectKey = config.projectKey,
        projectId = config.projectId,
        env = config.env,
        appVersion = config.appVersion;

    this.client = new _airbrakeJs2.default({ projectId: projectId, projectKey: projectKey });
    this.addContextFilter({ env: env, appVersion: appVersion });
    this.addBrowserFilter();
  }

  /*
   * Includes additional context information about the outgoing notice.
   */


  _createClass(AirbrakeErrorService, [{
    key: 'addContextFilter',
    value: function addContextFilter(_ref) {
      var env = _ref.env,
          appVersion = _ref.appVersion;

      this.client.addFilter(function (notice) {
        var updatedNotice = notice;
        updatedNotice.context.environment = env;
        updatedNotice.context.version = appVersion;
        return updatedNotice;
      });
    }
  }, {
    key: 'addBrowserFilter',
    value: function addBrowserFilter() {
      this.client.addFilter(function (notice) {
        var version = parseInt(_detectBrowser2.default.version, 10);
        switch (_detectBrowser2.default && _detectBrowser2.default.name) {
          case 'safari':
            // Support Desktop Safari >= 8
            return version >= 8 ? notice : null;
          case 'ie':
            // Support IE >= 11
            return version >= 11 ? notice : null;
          case 'ios':
            // Support Mobile Safari >= 8
            // We support iOS Safari 8 and above
            return version >= 8 ? notice : null;
          default:
            return notice;
        }
      });
    }

    /*
     * Notifies airbrake of the specified error.
     */

  }, {
    key: 'notify',
    value: function notify(err) {
      if (!err) return Promise.reject(new Error('Undefined err object'));
      if (!this.client) return Promise.reject(new Error('Undefined service client'));

      return this.client.notify(err).then(function (notice) {
        return notice && notice.id;
      });
    }
  }]);

  return AirbrakeErrorService;
}();

exports.default = AirbrakeErrorService;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/utils-airbrake/lib/index.js
// module id = 1560
// module chunks = 1